// Issue with watermelonDB library https://github.com/Nozbe/WatermelonDB/issues/629
// @ts-nocheck
import { Model, Q } from '@nozbe/watermelondb';
import { field, date, readonly } from '@nozbe/watermelondb/decorators';
import relation from '@nozbe/watermelondb/decorators/relation';
import { setGenerator } from '@nozbe/watermelondb/utils/common/randomId';
import { v4 as uuidv4 } from 'uuid';

setGenerator(uuidv4);

export default class EntryUser extends Model {
    static table = 'entry_users';

    static associations = {
        entry: { type: 'belongs_to', key: 'entry_id' },
        users: { type: 'belongs_to', key: 'user_id' },
        organisations: { type: 'belongs_to', key: 'organisation_id' },
    };

    @field('entry_id') entryId;
    @field('user_id') userId;
    @field('organisation_id') organisationId;

    @date('client_created_at') clientCreatedAt;
    @date('client_updated_at') clientUpdatedAt;
    @date('archived_at') archivedAt;
    @date('created_at') createdAt;
    @date('updated_at') updatedAt;

    @relation('entries', 'entry_id') entry;
    @relation('users', 'user_id') user;
    @relation('organisations', 'organisation_id') organisation;
}

export interface EntryUserSimple {
    id: string;
    entryId: string;
    userId: string;
    organisationId: string;
    clientCreatedAt: string;
    clientUpdatedAt: string;
    archivedAt: string;
    createdAt: string;
    updatedAt: string;
}
